const styles = {
    loadingContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
    },
    pageHeader: {
        backgroundColor: "#f5f5f5",
        padding: 4,
        borderRadius: 2,
        marginBottom: 2,
    },
    card: {
        borderRadius: 2,
        width: "100%",
        display: "flex",
        flexDirection: "column",
    },
    cardContent: {
        padding: 3,
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
    },
    dataGridPaper: {
        flexGrow: 1,
        overflow: "auto",
        padding: 2,
        borderRadius: 2,
    },
    dialogTextField: {
        marginBottom: 2,
        fontFamily: '"Plus Jakarta Sans", "Plus Jakarta Sans Fallback", Helvetica, Arial, sans-serif',
        wordBreak: "break-word",
    },
};

export default styles;
